export default {"src":"/_next/static/media/weather-working-4.eed95f47.svg","height":477,"width":460,"blurWidth":0,"blurHeight":0};